import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { PackagesPage } from './_dashboard.inventory.packages'

export const Route = createFileRoute('/_dashboard/inventory/packages/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: PackagesItemPage,
})

function PackagesItemPage() {
  const { item } = Route.useParams()
  return <PackagesPage selectedId={item} />
}
